import { Contact, ContactStatusEnum } from 'types/user';
import * as yup from 'yup';

export const getInitialValues = (contact: Contact | null) => ({
  fname: contact?.fname || '',
  lname: contact?.lname || '',
  sites: contact?.sites?.map((s) => s._id) || [],
  groups: contact?.groups?.map((g) => g._id) || [],
  role: contact?.role || '',
  phone: contact?.phone || '',
  email: contact?.email || '',
  isArchived: contact?.status === ContactStatusEnum.ARCHIVED,
});

const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

export const validationSchema = yup.object().shape({
  fname: yup.string().required('First name is required'),
  lname: yup.string().required('Last name is required'),
  role: yup.string(),
  email: yup.string().email().required('Email is a required field'),
  phone: yup.string().matches(phoneRegExp, 'Phone number is not valid'),
  groups: yup.array(),
  sites: yup.array(),
  isArchived: yup.boolean(),
});
